import Slider1 from './Slider1'
export default Slider1
